import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '@/lib/auth';
import { useKiprData } from '@/lib/kiprData';

const ProtectedRoute: React.FC<{ children: React.ReactNode; requireTrainingAccess?: boolean }> = ({
  children,
  requireTrainingAccess = false,
}) => {
  const location = useLocation();
  const { authEnabled, loading, user } = useAuth();
  const { loading: dataLoading, hasTrainingAccess } = useKiprData();

  if (!authEnabled) {
    return <>{children}</>;
  }

  if (loading) {
    return (
      <div className="min-h-screen bg-[#FAFAFA] flex items-center justify-center text-[#555555]">
        Loading your session...
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }

  if (requireTrainingAccess && (loading || dataLoading)) {
    return (
      <div className="min-h-screen bg-[#FAFAFA] flex items-center justify-center text-[#555555]">
        Loading your training access...
      </div>
    );
  }

  if (requireTrainingAccess && !hasTrainingAccess) {
    return <Navigate to="/profile?billingRequired=1" replace state={{ from: location }} />;
  }

  return <>{children}</>;
};

export default ProtectedRoute;
